export default __webpack_public_path__ + "static/media/013-roll cake.f144eb25.svg";